"use client";

import { useRef } from "react";
import SideMenu from "@/components/Sidemenu";
import { share } from "@/lib/share";

export default function MobileSommaire({ menuContent, page }) {
  const anchorRef = useRef(null);

  return (
    <div
      ref={anchorRef}
      className="sticky top-[60px] z-40 w-full self-start md:top-[100px] lg:hidden"
    >
      <SideMenu content={menuContent} mobileAnchorRef={anchorRef} />
      <button
        type="button"
        onClick={() => share()}
        className="mt-5 flex w-full cursor-pointer flex-row items-center justify-end gap-3"
      >
        Partager
        <img src="/icons/share.svg" alt="" width={20} height={20} aria-hidden />
      </button>
    </div>
  );
}
